import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import { MaterialHero } from "../../components/static-page-components/material-hero";
import EastIcon from "@mui/icons-material/East";
import { HashLink } from "react-router-hash-link";
import exceptionalClientsImage from "../../assets/our-homeowners-page/Every-Client-Exceptional_m.jpg";
import "./styles.scss";
import { StageItem } from "./stage-item";
import { Link } from "react-router";
import { Pages } from "../../utils";
import infoGraphic from "../../assets/our-homeowners-page/demographics and psychographics_d.jpg";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";
import MultipleStopOutlinedIcon from "@mui/icons-material/MultipleStopOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { StatItem } from "./stat-item";
import { PersonaCards } from "./persona-cards";
import { TheVettingProcess } from "../../components/the-vetting-process";

const statItems = [
  {
    icon: <Groups2OutlinedIcon />,
    stat: "30-55",
    description: "year-old homeowners are 73% more likely to hire a designer.",
  },
  {
    icon: <HomeOutlinedIcon />,
    stat: "44%",
    description:
      "of households earning $150K+ planned to renovate key home spaces in the coming years.",
  },
  {
    icon: <DesignServicesOutlinedIcon />,
    stat: "80%",
    description:
      "prioritize quality, functionality, and personalized design in their decision to hire a designer.",
  },
  {
    icon: <MapsHomeWorkOutlinedIcon />,
    stat: "20 - 30%",
    description:
      "or more of urban, high-income homeowners use interior designers than the general population.",
  },
  {
    icon: <MultipleStopOutlinedIcon />,
    stat: "80%",
    description:
      "of homeowners (families or empty nesters) seek both aesthetics and functionality.",
  },
  {
    icon: <PersonOutlineOutlinedIcon />,
    stat: "84%",
    description: "of homeowners trust expert advice when hiring a designer.",
  },
];

export const HomeownerPage = () => {
  return (
    <div className="page homeowner-page">
      <MaterialHero title="OUR HOMEOWNERS" />

      <LandingPageSection className="exceptional-section">
        <Grid2 container columns={12}>
          <Grid2
            size={{
              xs: 12,
              md: 6,
            }}
            justifyContent={"space-around"}
            alignItems={"center"}
            alignContent={"center"}
          >
            <Typography
              mb="16px"
              variant="h4"
              className="text-pink text-left font-size-5"
            >
              Every Client, Exceptional.
            </Typography>
            <Typography
              mb="28px !important"
              variant="h6"
              sx={{ ml: 0, fontWeight: 600 }}
              className="margin-top-0 contain-title"
            >
              From first interaction to finished project, we prepare homeowners
              to be your dream clients.
            </Typography>
            <Button
              component={HashLink}
              to="#persona-cards"
              endIcon={<EastIcon />}
              size="large"
              variant="contained"
            >
              Meet Our Homeowners
            </Button>
          </Grid2>

          <Grid2
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <img
              className="full-width-image exceptional-client-image"
              src={exceptionalClientsImage}
              alt="Group of homeowner clients"
            />
          </Grid2>
        </Grid2>
      </LandingPageSection>

      <LandingPageSection>
        <Typography
          variant={"display2" as any}
          component={"h2"}
          mb="16px"
          className="text-center font-size-6 text-pink font-title"
        >
          WHO WE TARGET
        </Typography>
        <Typography
          variant="h5"
          component="p"
          fontWeight={400}
          className="text-center contain-title"
          sx={{ mx: "auto", mt: "1rem", maxWidth: "720px !important" }}
        >
          Our marketing efforts target homeowners who are currently searching to
          hire an Interior Designer or Decorator as well as those who have never
          hired a designer before but would be highly likely with a little
          encouragement from us!
        </Typography>
      </LandingPageSection>

      <LandingPageSection>
        <Grid2 container columns={12} spacing={"64px"}>
          <Grid2
            size={{
              xs: 12,
              md: 6,
            }}
            alignContent={"center"}
          >
            <Typography variant="h4" className="font-size-5 text-pink">
              Empowering Homeowners With Knowledge & Confidence Before They
              Connect With You
            </Typography>

            <Typography
              variant="body1"
              className="font-size-3 contain-text"
              sx={{ mt: "1rem" }}
            >
              Once a homeowner has joined Home Design Guild we send them on an
              exciting journey of discovery, discernment and definition in three
              distinct onboarding stages.
            </Typography>

            <Typography
              variant="body1"
              className="font-size-3 contain-text"
              sx={{ mt: "1rem" }}
            >
              Our goal is to ensure when they connect with you each homeowner
              has a broad understanding of how designers work, bill and have set
              expectations on what to expect from a cost and timeline
              perspective.
            </Typography>
          </Grid2>

          <Grid2
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <StageItem
              title="Discover"
              description="Homeowners Learn What Interior Design Can Do for Them"
              stage={1}
            />
            <StageItem
              title="Discern"
              description="Educating Homeowners on Realistic Expectations and the Designer-Client Relationship"
              stage={2}
            />
            <StageItem
              title="Define"
              description="Helping Homeowners Clearly Articulate Their Design Needs"
              stage={3}
            />
            <Button
              endIcon={<EastIcon />}
              component={Link}
              to={Pages.SIGNUP}
              size="large"
              variant="outlined"
              className="font-size-4"
            >
              Join To See Full Insights
            </Button>
          </Grid2>
        </Grid2>
      </LandingPageSection>

      <LandingPageSection sx={{ pb: 0 }}>
        <Typography
          variant="h4"
          sx={{
            mb: "16px",
          }}
          className="text-center font-size-5 text-pink font-body"
        >
          One Size Does Not Fit All
        </Typography>
        <Typography
          variant="body1"
          className="text-center font-size-3 contain-text-small"
          sx={{ mx: "auto", mt: "1rem" }}
        >
          Our homeowners come from a variety of demographic and psychographic
          backgrounds, but they often share certain characteristics. Here’s a
          high level overview of some of the common characteristics of our
          homeowners.
        </Typography>
      </LandingPageSection>

      <LandingPageSection>
        <Grid2 container columns={12} spacing={{ xs: 4, md: 2 }}>
          {statItems.map((item) => (
            <Grid2
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <StatItem
                icon={item.icon}
                stat={item.stat}
                description={item.description}
              />
            </Grid2>
          ))}
        </Grid2>
      </LandingPageSection>

      <LandingPageSection className="text-center">
        <img
          src={infoGraphic}
          alt={"demographics and psychographics"}
          className="full-width-image"
        />
        <Typography variant="overline" className="text-purple">
          BECOME A LEGENDARY DESIGNER
        </Typography>
        <Typography
          variant="h4"
          sx={{ mx: "auto", mb: "16px" }}
          className="text-center font-size-5 text-pink font-body contain-title"
        >
          Join Home Design Guild Today – Unlock Exclusive Insights Into Your
          Ideal Client.
        </Typography>
        <Typography
          variant="body1"
          className="text-center font-size-3 contain-text"
          sx={{ mx: "auto", mt: "1rem", mb: "28px" }}
        >
          Access powerful demographics and psychographics data to elevate your
          business and connect with the right homeowner.
        </Typography>
        <Stack
          sx={{ mt: 3, maxWidth: "620px", mx: "auto" }}
          justifyContent={"center"}
          spacing={2}
          direction={{
            sx: "column",
            sm: "row",
          }}
          alignContent="center"
        >
          <Button
            endIcon={<EastIcon />}
            variant="outlined"
            component={Link}
            to={Pages.COMING_SOON}
            sx={{ width: "100%" }}
          >
            Preview The Data
          </Button>
          <Button
            endIcon={<EastIcon />}
            variant="contained"
            component={Link}
            to={Pages.SIGNUP}
            sx={{
              width: "100%",
              mt: {
                xs: 1.5,
                sm: 0,
              },
            }}
          >
            Apply Now
          </Button>
        </Stack>
      </LandingPageSection>

      <div id="persona-cards">
        <LandingPageSection
          sx={{
            pb: 0,
          }}
        >
          <Typography
            variant={"display2" as any}
            component="h2"
            className="text-center font-size-5 text-pink font-title"
          >
            MEET YOUR FUTURE CLIENTS
          </Typography>
          <Typography
            variant="body1"
            className="text-center font-size-3 contain-text"
            sx={{ mx: "auto", mt: "1rem", mb: 3 }}
          >
            We like to bring our target customers to life, give them a name and
            a lifestyle, it helps us envision the type of experience, messaging
            and expectations they will have for us and for you.
          </Typography>
        </LandingPageSection>

        <LandingPageSection
          sx={{
            overflowX: "auto",
            overflowY: "hidden",
            pt: 4,
          }}
        >
          <PersonaCards />
        </LandingPageSection>
      </div>

      <TheVettingProcess />

      <LandingPageSection className="pink-section text-center">
        <Typography
          variant="h4"
          sx={{ mb: 2, fontWeight: 600 }}
          className="font-size-5 font-body title"
        >
          Start Fueling Your Future With Home Design Guild.
        </Typography>
        <Typography variant="body1" color="white" sx={{ mb: 3 }} className="text-white">
          Join Home Design Guild and experience the difference a designer-first
          platform can make.
        </Typography>
        <Button
          component={Link}
          to={Pages.SIGNUP}
          color={"white" as any}
          variant="contained"
          size="large"
          sx={{ fontWeight: 600 }}
          className="font-size-3 font-body"
        >
          Apply Now
        </Button>
      </LandingPageSection>
    </div>
  );
};
